import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { RankingCliente } from './ranking-cliente.model';

@Injectable()
export class VeiculosClvService extends ServiceCRUD {

  private baseUrlService: string;
  public carregando = true;

  private valorRetorno = new BehaviorSubject<any>(null);
  valorModal$ = this.valorRetorno.asObservable();

  constructor(
    public httpClient: HttpClient,
    router: Router,
    protected toastr: ToastrService)
    {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/veiculos/clv`;
  }

  public getPercentuais(): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService}/parametros/listar_percentual`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      })
    });
  }

  atualizarModal(event: any){
    this.valorRetorno.next(event)
  }

  receberValorModal(){
    return this.valorRetorno.getValue()
  }


  public getDados(
    dataInc?: any,
    dataFim?: any,
    chassi?: any,
    cpf?: any, filter?: any): Observable<any> {
      return this.httpClient.get<any>(`${this.baseUrlService + '/veiculo/Customer_Life'}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
        }),
        params: new HttpParams()
          .set('dataInc', dataInc ? dataInc.toString() : '')
          .set('dataFim', dataFim ? dataFim.toString() : '')
          .set('chassi', chassi ? chassi.toString() : '')
          .set('cpf', cpf ? cpf.toString() : '')
      });
  }

  public getRanking(): Observable<RankingCliente[]> {
    return this.httpClient.get<RankingCliente[]>(`${this.baseUrlService}/veiculo/Customer_Life/ranking`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      })
    });
  }
}


// return this.httpClient.get<any>(`${this.baseUrlService + '/veiculo/Customer_Life'}`, {
//   headers: new HttpHeaders({
//     'Content-Type': 'application/json',
//     'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
//   }),
//   params: new HttpParams()
//     .set('dataInc', dataInc.toString())
//     .set('dataFim', dataFim.toString())
//     .set('chassi', chassi.toString())
//     .set('cpf', cpf.toString())
// });


